//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import { Part } from "components/styles";
//#endregion
//#region Components
import FileErrorsBlock from "components/FileErrorsBlock/FileErrorsBlock";
import Message from "components/Message/Message";
import DataField from "components/FileErrorsBlock/components/DataField/DataField";
//#endregion

const ResumeStep1 = ({
    form, 
    errorStack
}) => {
    const { fileData } = form;
    const [fileDataCopy, setFileDataCopy] = useState({
        base64: "",
        name: "- Sin contenido -"
    });
    useEffect(() => {
        if (!fileData.base64) return;
        setFileDataCopy({ 
            base64: fileData.base64,
            name: fileData.name
        });
    }, [fileData]);
    return (
        <Part gap="25px">
            <DataField
                quantityRows={errorStack.rowCountFile}
                file={{
                    url: `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${fileDataCopy.base64}`,
                    name: fileDataCopy.name
                }}/>
            {errorStack.stack.length === 0 && errorStack.rowCountFile > 0 
            ? <Message 
                success 
                quantityErrors={errorStack.stack.length} 
                quantityRows={errorStack.rowCountFile}/>
            : <FileErrorsBlock errorStack={errorStack}/>}
        </Part>
    );
}

export default ResumeStep1;